var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one_swiper"},[_c('el-carousel',_vm._l((_vm.lunbolist),function(item,index){return _c('el-carousel-item',{key:index,staticStyle:{"height":"550px"}},[_c('img',{staticStyle:{"height":"550px","width":"100%"},attrs:{"src":item.thumb,"alt":""},on:{"click":function($event){return _vm.todetail(item)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }